import React, { useState } from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
import { Checkbox, Select, Row, Col, Typography, Divider, Card, Form, message } from "antd";

const { Text } = Typography;
const { Option } = Select;

const WeeklyOffs = () => {
    const [selectedDays, setSelectedDays] = useState<string[]>([]);
    const [daySelections, setDaySelections] = useState<Record<string, string[]>>({});
    const [dropdownValues, setDropdownValues] = useState<Record<string, string>>({});

    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const dayOption = (day: string) => [`All ${day}`, `1st ${day}`, `2nd ${day}`, `3rd ${day}`, `4th ${day}`, `Last ${day}`];

    const handleDaySelection = (checkedValues: string[]) => {
        setSelectedDays(checkedValues);
    };

    const handleCheckboxChange = (day: string, option: string, checked: boolean) => {
        setDaySelections(prev => {
            const updatedSelections = { ...prev };
            const dayOptions = updatedSelections[day] || [];

            if (checked) {
                updatedSelections[day] = Array.from(new Set([...dayOptions, option]));
            } else {
                updatedSelections[day] = dayOptions.filter(opt => opt !== option);
            }

            if (option.startsWith("All")) {
                updatedSelections[day] = checked ? dayOption(day) : [];
            }

            return updatedSelections;
        });
    };

    const handleDropdownChange = (day: string, option: string, value: string) => {
        setDropdownValues(prev => {
            const updatedDropdownValues = { ...prev };

            if (option.startsWith("All")) {
                dayOption(day).forEach(opt => {
                    updatedDropdownValues[`${day}-${opt}`] = value;
                });
            } else {
                updatedDropdownValues[`${day}-${option}`] = value;
            }

            return updatedDropdownValues;
        });
    };

    const renderOptionsWithFormList = (day: string, options: string[], fields: any[]) => {
        return options.map((option, index) => {
            const isAllSelected = daySelections[day]?.includes(`All ${day}`);
            const isOptionDisabled = isAllSelected && option !== `All ${day}`;
            return (
                <Row style={{ marginBottom: 10 }}>
                    <Col span={8}>
                        <Form.Item
                            name={[index, 'checked']}
                            valuePropName="checked"
                            style={{ marginBottom: 0 }}
                        >
                            <Checkbox
                                checked={daySelections[day]?.includes(option)}
                                onChange={e => handleCheckboxChange(day, option, e.target.checked)}
                                disabled={isOptionDisabled}
                            >
                                {option}
                            </Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={16}>
                        <Form.Item
                            name={[index, 'dropdown']}
                            style={{ marginBottom: 0 }}
                        >
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select Weekly Off"
                                value={dropdownValues[`${day}-${option}`]}
                                onChange={value => handleDropdownChange(day, option, value)}
                                disabled={isOptionDisabled}
                                allowClear
                            >
                                <Option value="fullDay">Full Day Weekly Off</Option>
                                <Option value="halfDay">Half Day Weekly Off</Option>
                                <Option value="noOff">No Weekly Off</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            );
        })
    };


    const config: MasterConfigs = {
        api: () => '/weekly-offs',
        title: 'Weekly Offs',
        modalTitle: () => config.title,
        isActionTab: true,
        onDataLoad: (data: any) => {
            setSelectedDays(data?.weeklyoffdays || [])
        },
        onRefresh: () => {
            setSelectedDays(null)
            setDaySelections(null)
            setDropdownValues(null)
        },
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
            {
                type: 'custom',
                span: 24,
                formItem: () => (
                    <div>
                        <Text>Select the Weekly Off days</Text>
                        <Form.Item
                            name={'weeklyoffdays'}
                        >
                            <Checkbox.Group style={{ marginTop: 10 }} onChange={handleDaySelection}>
                                {days.map(day => (
                                    <Checkbox key={day} value={day} style={{ marginRight: 20 }}>
                                        {day}
                                    </Checkbox>
                                ))}
                            </Checkbox.Group>
                        </Form.Item>

                        <Divider />
                        <Row gutter={[16, 16]}>
                            {selectedDays?.map(day => (
                                <Form.List name={['days', day]} key={day}>
                                    {(fields, { add }) => (
                                        <Col span={12} key={day}>
                                            <Card title={day} bordered={true} style={{ marginBottom: 20 }}>
                                                {renderOptionsWithFormList(day, dayOption(day), fields)}
                                            </Card>
                                        </Col>
                                    )}
                                </Form.List>
                            ))}
                        </Row>
                    </div>
                )
            }
        ],
        actions: [{ actionType: 'Add', name: 'Add' }]
    };

    return <MasterComponent config={config} />;
};

export default WeeklyOffs;
